import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {DomainService} from '../../../services/domain.service';
import {RequestConfirmationHelperObject} from '../../../model/RequestConfirmationHelperObject';
import {Location} from '@angular/common';
import {Observable} from 'rxjs';
import {TopLevelDomainVO} from '../../../generate/TopLevelDomainVO';
import {ChangeVO} from '../../../generate/ChangeVO';
import {RequestMetadata} from '../../../generate/RequestMetadata';
import {CommonStrings} from '../../../model/CommonStrings';
import {ErrorVO} from '../../../generate/ErrorVO';
import {ChangeRequestVO, TldChangeResultVO} from '../../../generate/TldChangeResultVO';
import {UtilService} from '../../../util/util.service';
import {FormControl, FormGroup} from '@angular/forms';
import {requiredFieldValidator} from '../../../validators/required-field-validator.directive';
import {whitelistCharacterValidator} from '../../../validators/valid-character-validator.directive';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'review-changes',
  templateUrl: './review-changes.component.html',
  styleUrls: ['./review-changes.component.scss']
})
export class ReviewChangesComponent implements OnInit {

  @Input()
  domain: TopLevelDomainVO;

  @Input()
  domainChange: ChangeVO;

  @Input()
  requestMetadata: RequestMetadata;

  @Output()
  decision = new EventEmitter<any>();


  @Input()
  updateChangeRequest: boolean;

  changeRequests: Array<ChangeRequestVO>;

  loadingData: boolean;

  errorMessages: string[] = [];
  form: FormGroup;
  isStaffUI = false;

  constructor(private domainService: DomainService,
              private userService: UserService,
              private util: UtilService,
              private location: Location,
              @Inject('env') private environment) {
  }

  ngOnInit() {
    this.loadingData = true;
    this.isStaffUI = this.environment.config.interfaceType === 'STAFF';
    this.initForm();
    this.domainService.splitRequest(this.domain).subscribe(response => {
      this.changeRequests = response;
    }, () => {
      this.loadingData = false;
    }, () => {
      this.loadingData = false;
    });

  }

  confirm() {
    this.loadingData = true;
    this.requestMetadata.comment = this.form.get('comment').value;
    let response: Observable<TldChangeResultVO>;

    if(this.updateChangeRequest){
      response = this.domainService
        .updateExistingChangeRequest(this.domain, this.requestMetadata);
    }else{
      response = this.domainService
        .confirmChangeRequest(this.domain, this.requestMetadata);
    }

    response.subscribe(data => {
      const helper: RequestConfirmationHelperObject = {
        tldChangeResult: data
      };
      this.decision.emit(helper);
    }, error => {
      console.log(error);
      if (error.errorCode === 400) {
        this.buildAllErrorMessages(error.message, this.errorMessages);
      } else {
        this.errorMessages.push(error.message);
      }
      this.loadingData = false;
    }, () => {
      this.loadingData = false;
    });
  }

  goBack(): void {
    this.decision.emit(CommonStrings.BACK);
  }

  cancel() {
    this.location.back();
  }

  buildAllErrorMessages(errors: ErrorVO, messages: string[]): string[] {
    for (const err of errors.errorMessages) {
      this.errorMessages.push(err);
    }

    this.buildNonGlobalErrorMessages(errors, messages);

    if (messages.length === 1 && this.util.checkIfEmpty(messages[0])) {
      messages[0] = 'Internal server error!!';
    }
    return messages;
  }


  private buildNonGlobalErrorMessages(errors: ErrorVO, messages: string[]) {
    for (const error of errors.errors) {
      if (error != null) {
        for (const err of error.errorMessages) {
          messages.push(this.formatErrorMessage(errors.field, error.field, err));
        }
      }
      this.buildNonGlobalErrorMessages(error, messages);
    }
  }


  private formatErrorMessage(fieldRoot: string, field: string, error: string) {
    return this.util.capatalizeFirstChar(field) + ' in ' + this.util.capatalizeFirstChar(fieldRoot) + ' has an error message - ' + error;
  }


  private initForm() {
    if (this.requestMetadata.requestType !== 'DIRECT') {
      this.form = new FormGroup({
        [`comment`]: new FormControl('', [])
      });
    } else {
      this.form = new FormGroup({
        [`comment`]: new FormControl('', [requiredFieldValidator, whitelistCharacterValidator])
      });
    }
  }

}
